(() => {
  const initialize = (scope = document) => {
    scope.querySelectorAll('[data-hc-controls]').forEach(form => {
      if (form.dataset.initialized) return;
      form.dataset.initialized = 'true';
      const sort = form.querySelector('[data-hc-sort]');
      const apply = form.querySelector('[data-hc-sort-apply]');
      if (sort) {
        if (apply) apply.hidden = true;
        sort.addEventListener('change', () => form.requestSubmit());
      }
      form.querySelectorAll('[data-hc-filter]').forEach(details => {
        details.addEventListener('toggle', () => {
          if (!details.open) return;
          form.querySelectorAll('[data-hc-filter]').forEach(other => {
            if (other !== details) other.open = false;
          });
        });
        details.addEventListener('keydown', event => {
          if (event.key !== 'Escape') return;
          details.open = false;
          details.querySelector('summary')?.focus();
        });
      });
    });
  };
  initialize();
  document.addEventListener('click', event => {
    document.querySelectorAll('[data-hc-filter][open]').forEach(details => {
      if (!details.contains(event.target)) details.open = false;
    });
  });
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
